/* KAIROS desktop gallery 1.0. Existing Swiper 8 + PhotoSwipe 5; no polling. */
(() => {
  'use strict';
  if (window.__kairosDesktopGalleryV1) return;
  window.__kairosDesktopGalleryV1 = true;
  const desktop = window.matchMedia('(min-width: 750px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  let activeViewer = null;
  const tr = {
    open: 'G\u00f6rseli b\u00fcy\u00fct', close: 'Kapat',
    gallery: '\u00dcr\u00fcn g\u00f6rselleri',
    previous: '\u00d6nceki g\u00f6rsel', next: 'Sonraki g\u00f6rsel',
    error: 'G\u00f6rsel y\u00fcklenemedi. Kapat\u0131p yeniden deneyin.'
  };
  const svg = path => `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${path}" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const closeSVG = svg('M5 5l14 14M19 5 5 19');
  const prevSVG = svg('m14.5 5-7 7 7 7');
  const nextSVG = svg('m9.5 5 7 7-7 7');

  function restoreAttributes(el, names) {
    const saved = names.map(name => [name, el.getAttribute(name)]);
    return () => saved.forEach(([name, value]) => {
      if (value === null) el.removeAttribute(name); else el.setAttribute(name, value);
    });
  }
  function restoreStyles(el, names) {
    const saved = names.map(name => [name, el.style.getPropertyValue(name), el.style.getPropertyPriority(name)]);
    return () => saved.forEach(([name, value, priority]) => {
      if (value) el.style.setProperty(name, value, priority); else el.style.removeProperty(name);
    });
  }
  function lockPage() {
    const body = document.body, html = document.documentElement;
    const x = window.scrollX, y = window.scrollY;
    const width = html.clientWidth;
    const restoreBody = restoreStyles(body, ['position', 'top', 'left', 'width', 'overflow']);
    const restoreHtml = restoreStyles(html, ['overflow', 'scroll-behavior']);
    body.style.position = 'fixed'; body.style.top = `${-y}px`; body.style.left = `${-x}px`;
    body.style.width = `${width}px`; body.style.overflow = 'hidden'; html.style.overflow = 'hidden';
    let restored = false;
    return () => {
      if (restored) return;
      restored = true; restoreBody();
      html.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(x, y); restoreHtml();
    };
  }
  function imageData(media, slide) {
    if (slide.dataset.mediaType !== 'image') return null;
    const id = slide.dataset.mediaId;
    const link = Array.from(media.querySelectorAll('a[data-pswp-image]')).find(el => el.dataset.mediaId === id);
    if (!link) return null;
    let src;
    try { src = new URL(link.dataset.pswpSrc || link.getAttribute('href'), location.href); }
    catch (_) { return null; }
    const width = Number(link.dataset.pswpWidth), height = Number(link.dataset.pswpHeight);
    if (!['https:', 'http:'].includes(src.protocol) || !(width > 0 && height > 0)) return null;
    const img = slide.querySelector('img');
    return { id, src: src.href, width, height, element: slide,
      msrc: img?.currentSrc || img?.src || src.href, alt: img?.alt || tr.gallery };
  }

  function openViewer(owner, id, focusTarget) {
    if (!desktop.matches || activeViewer || document.querySelector('.pswp--open') || typeof window.PhotoSwipe !== 'function') return;
    const photos = owner.slides.map(slide => imageData(owner.media, slide)).filter(Boolean);
    const index = photos.findIndex(photo => photo.id === id);
    if (index < 0) return;
    const viewer = new window.PhotoSwipe({
      dataSource: photos, index, mainClass: 'kdg-lightbox', appendToEl: document.body,
      bgOpacity: 1, loop: false, preload: [1, 1],
      initialZoomLevel: 'fit',
      secondaryZoomLevel: level => Math.max(level.fit, Math.min(1, level.fit * 2)),
      maxZoomLevel: level => Math.max(1, level.fit * 3),
      paddingFn: viewport => {
        const side = Math.max(64, Math.round(viewport.x * .055), (viewport.x - 1440) / 2);
        const vertical = Math.max(32, Math.round(viewport.y * .065), (viewport.y - 1080) / 2);
        return { top: vertical, bottom: vertical, left: side, right: side };
      },
      // Use current viewport dimensions, never the product column's cached size.
      getViewportSizeFn: () => ({ x: document.documentElement.clientWidth, y: window.innerHeight }),
      showHideAnimationType: reduced.matches ? 'none' : 'fade',
      showAnimationDuration: reduced.matches ? 0 : 260,
      hideAnimationDuration: reduced.matches ? 0 : 220,
      zoomAnimationDuration: reduced.matches ? 0 : 300,
      easing: 'cubic-bezier(.22,.68,0,1)',
      closeOnVerticalDrag: false, pinchToClose: false, allowPanToNext: true,
      imageClickAction: 'zoom', tapAction: 'zoom', doubleTapAction: 'zoom',
      bgClickAction: 'close', wheelToZoom: false, clickToCloseNonZoomable: false,
      arrowPrev: true, arrowNext: true, zoom: false, counter: false,
      closeSVG, arrowPrevSVG: prevSVG, arrowNextSVG: nextSVG,
      closeTitle: tr.close, arrowPrevTitle: tr.previous, arrowNextTitle: tr.next,
      errorMsg: tr.error, trapFocus: true, returnFocus: false,
      escKey: true, arrowKeys: true
    });
    let ready = false, requestedClose = false, cleaned = false, selectedId = id;
    let unlock = () => {};
    const sync = () => {
      if (owner.disposed || owner.swiper.destroyed) return;
      const i = Array.from(owner.swiper.slides).findIndex(slide => slide.dataset.mediaId === selectedId);
      if (i >= 0) owner.swiper.slideTo(i, 0);
    };
    const handle = {
      owner,
      close(immediate = false) {
        requestedClose = true;
        if (immediate) { viewer.options.hideAnimationDuration = 0; unlock(); }
        if (ready) viewer.close();
      }
    };
    activeViewer = handle;
    const cleanup = () => {
      if (cleaned) return;
      cleaned = true; unlock();
      if (activeViewer === handle) activeViewer = null;
      sync(); owner.updateAccess();
      const target = owner.slides.find(slide => slide.dataset.mediaId === selectedId)?.querySelector('[data-kdg-zoom]') || focusTarget;
      if (!owner.disposed && desktop.matches && target?.isConnected) target.focus({ preventScroll: true });
    };
    viewer.on('afterInit', () => {
      viewer.element.setAttribute('aria-label', tr.gallery);
      viewer.element.setAttribute('aria-modal', 'true');
      viewer.element.querySelector('.pswp__button--close')?.addEventListener('click', event => {
        event.preventDefault(); event.stopImmediatePropagation(); handle.close();
      }, true);
      unlock = lockPage();
    });
    viewer.on('openingAnimationEnd', () => { ready = true; if (requestedClose) viewer.close(); });
    viewer.on('change', () => { selectedId = photos[viewer.currIndex]?.id || id; });
    viewer.on('close', sync);
    viewer.on('destroy', cleanup);
    try { if (viewer.init() === false) cleanup(); }
    catch (error) {
      try { viewer.destroy(); } catch (_) { /* Ensure the page is usable even on a library failure. */ }
      viewer.element?.remove(); cleanup();
      console.warn('[Kairos desktop gallery] Viewer could not open.', error);
    }
  }

  class DesktopGallery {
    constructor(media, slider, swiper) {
      this.media = media; this.slider = slider; this.swiper = swiper;
      this.frame = slider.parentElement; this.disposed = false;
      this.cleanups = []; this.raf = 0; this.layoutKey = '';
      this.ignoreClickUntil = 0; this.pointer = null;
      const seen = new Set();
      this.slides = Array.from(swiper.slides).filter(slide => {
        const id = slide.dataset.mediaId;
        if (!id || seen.has(id) || slide.classList.contains('swiper-slide-duplicate')) return false;
        seen.add(id); return true;
      });
      this.cleanups.push(restoreStyles(this.frame, ['--kdg-stage', '--kdg-gutter']));
      this.media.classList.add('kdg-ready');
      this.configureSlider();
      this.enableZoom();
      this.onSwiper('slideChange', () => this.updateAccess());
      this.onSwiper('destroy', () => this.destroy());
      this.on(window, 'resize', () => this.scheduleLayout(), { passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.scheduleLayout());
        this.observer.observe(this.frame);
      }
      this.measure(); this.updateAccess();
    }
    on(node, name, fn, options) {
      node.addEventListener(name, fn, options);
      this.cleanups.push(() => node.removeEventListener(name, fn, options));
    }
    onSwiper(name, fn) {
      this.swiper.on(name, fn);
      this.cleanups.push(() => { if (this.swiper.off) this.swiper.off(name, fn); });
    }
    configureSlider() {
      const overrides = { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0,
        centeredSlides: false, autoHeight: false, slidesOffsetBefore: 0, slidesOffsetAfter: 0 };
      // Save only the fields we change; keep all theme listeners and thumbnail bindings.
      this.parameterBackups = ['params', 'originalParams'].map(key => {
        const obj = this.swiper[key];
        const saved = Object.keys(overrides).concat('breakpoints').map(name => [name, Object.prototype.hasOwnProperty.call(obj, name), obj[name]]);
        Object.assign(obj, overrides);
        if (obj.breakpoints) obj.breakpoints = Object.fromEntries(Object.entries(obj.breakpoints).map(([point, values]) => [point, { ...values, ...overrides }]));
        return { key, saved };
      });
      this.swiper.currentBreakpoint = undefined;
    }
    scheduleLayout() {
      if (this.raf || this.disposed) return;
      this.raf = requestAnimationFrame(() => { this.raf = 0; this.measure(); });
    }
    measure() {
      if (this.disposed || !desktop.matches || this.swiper.destroyed) return;
      const width = Math.round(this.frame.getBoundingClientRect().width);
      if (width < 1) return;
      const thumbs = this.frame.querySelector('.swiper-thumbs');
      const visibleThumbs = thumbs && window.getComputedStyle(thumbs).display !== 'none';
      const gutter = visibleThumbs ? 104 : 0;
      const stage = Math.round(Math.min(width - gutter, Math.max(260, window.innerHeight * .76), 860));
      const key = `${width}:${stage}:${gutter}`;
      if (key === this.layoutKey) return;
      this.layoutKey = key;
      this.frame.style.setProperty('--kdg-stage', `${stage}px`);
      this.frame.style.setProperty('--kdg-gutter', `${gutter}px`);
      this.swiper.update();
      const thumbSwiper = this.swiper.thumbs?.swiper;
      if (thumbSwiper && !thumbSwiper.destroyed) thumbSwiper.update();
      if (visibleThumbs) {
        const frameRect = this.frame.getBoundingClientRect(), thumbRect = thumbs.getBoundingClientRect();
        const left = thumbRect.left - frameRect.left + thumbRect.width / 2;
        [['.kairos-floating-thumb-up', thumbRect.top - frameRect.top - 18], ['.kairos-floating-thumb-down', thumbRect.bottom - frameRect.top + 6]].forEach(([selector, top]) => {
          const button = this.frame.querySelector(selector);
          if (button) { button.style.left = `${left}px`; button.style.top = `${top}px`; }
        });
      }
    }
    updateAccess() {
      if (this.disposed || this.swiper.destroyed) return;
      const activeId = this.swiper.slides[this.swiper.activeIndex]?.dataset.mediaId;
      this.slides.forEach(slide => {
        const target = slide.querySelector('[data-kdg-zoom]');
        if (target) target.tabIndex = slide.dataset.mediaId === activeId ? 0 : -1;
      });
    }
    enableZoom() {
      this.slides.forEach(slide => {
        if (!imageData(this.media, slide)) return;
        // A child target avoids modifying the mobile module's slide attributes.
        const target = slide.querySelector('.media');
        if (!target) return;
        this.cleanups.push(restoreAttributes(target, ['role', 'tabindex', 'aria-label', 'aria-haspopup', 'data-kdg-zoom']));
        target.setAttribute('data-kdg-zoom', ''); target.setAttribute('role', 'button');
        target.setAttribute('aria-label', tr.open); target.setAttribute('aria-haspopup', 'dialog'); target.tabIndex = -1;
      });
      this.media.querySelectorAll('a[data-pswp-image]').forEach(link => {
        if (!this.slides.some(slide => slide.dataset.mediaId === link.dataset.mediaId && slide.querySelector('[data-kdg-zoom]'))) return;
        const opener = link.closest('.product__gallery-opener');
        if (!opener) return;
        opener.classList.add('kdg-image-opener');
        this.cleanups.push(() => opener.classList.remove('kdg-image-opener'));
      });
      this.on(this.frame, 'pointerdown', event => {
        if (event.isPrimary === false) { this.ignoreClickUntil = Date.now() + 600; this.pointer = null; return; }
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { passive: true });
      const moved = event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        if (Math.hypot(event.clientX - this.pointer.x, event.clientY - this.pointer.y) > 8) this.ignoreClickUntil = Date.now() + 600;
      };
      this.on(this.frame, 'pointermove', moved, { passive: true });
      this.on(this.frame, 'pointerup', event => { moved(event); this.pointer = null; }, { passive: true });
      this.on(this.frame, 'pointercancel', () => { this.pointer = null; this.ignoreClickUntil = Date.now() + 600; }, { passive: true });
      this.onSwiper('sliderFirstMove', () => { this.ignoreClickUntil = Date.now() + 600; });
      this.on(this.frame, 'click', event => {
        if (!desktop.matches || event.button > 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        const target = event.target.closest('[data-kdg-zoom]');
        const slide = target?.closest('.swiper-slide');
        const link = event.target.closest('a[data-pswp-image]');
        if ((!slide || slide.parentElement !== this.slider.querySelector('.swiper-wrapper')) && !link) return;
        event.preventDefault(); event.stopImmediatePropagation();
        if (Date.now() < this.ignoreClickUntil || this.swiper.allowClick === false || this.swiper.animating) return;
        openViewer(this, slide?.dataset.mediaId || link?.dataset.mediaId, target || link);
      }, true);
      this.on(this.frame, 'keydown', event => {
        const target = event.target.closest('[data-kdg-zoom]');
        if (!target || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault(); event.stopPropagation();
        openViewer(this, target.closest('.swiper-slide').dataset.mediaId, target);
      });
    }
    destroy() {
      if (this.disposed) return;
      this.disposed = true;
      if (activeViewer?.owner === this) activeViewer.close(true);
      cancelAnimationFrame(this.raf); this.observer?.disconnect();
      this.cleanups.forEach(fn => fn());
      this.media.classList.remove('kdg-ready'); controllers.delete(this.media);
      if (!this.swiper.destroyed) {
        this.parameterBackups.forEach(({key, saved}) => saved.forEach(([name, existed, value]) => {
          if (existed) this.swiper[key][name] = value; else delete this.swiper[key][name];
        }));
        this.swiper.currentBreakpoint = undefined; this.swiper.update();
        if (this.swiper.thumbs?.swiper && !this.swiper.thumbs.swiper.destroyed) this.swiper.thumbs.swiper.update();
      }
    }
  }

  function scan(scope = document) {
    for (const [media, controller] of controllers) if (!desktop.matches || !media.isConnected) controller.destroy();
    if (!desktop.matches || !scope.querySelectorAll || typeof window.PhotoSwipe !== 'function') return;
    scope.querySelectorAll('[data-main-product] product-media').forEach(media => {
      if (controllers.has(media)) return;
      const slider = media.querySelector('.product__media-slider > .swiper[data-slider]');
      const swiper = media.settings?.sliderInstance || slider?.swiper;
      if (!slider || !swiper || swiper.destroyed || !swiper.initialized || !swiper.slides?.length) return;
      controllers.set(media, new DesktopGallery(media, slider, swiper));
    });
  }
  const start = () => scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.customElements?.whenDefined('product-media').then(start);
  window.addEventListener('load', start, { once: true });
  desktop.addEventListener('change', start);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [media, controller] of controllers) if (event.target.contains(media)) controller.destroy();
  });
  window.addEventListener('pagehide', () => activeViewer?.close(true));
  window.addEventListener('pageshow', event => { if (event.persisted) activeViewer?.close(true); scan(); });
})();
